import "core-js/modules/es.array.join.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "是否开放"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.subjectStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "subjectStatus", $$v);
      },
      expression: "searchForm.subjectStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: "关闭",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "开放",
      value: "2"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "是否推荐"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.isRecommend,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "isRecommend", $$v);
      },
      expression: "searchForm.isRecommend"
    }
  }, [_c("el-option", {
    attrs: {
      label: "未推荐",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "已推荐",
      value: "1"
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {};
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "编号",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-lifestyle-table-link", {
          attrs: {
            id: scope.row.id,
            token: scope.row.token,
            title: scope.row.code
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.name",
      label: "姓名",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          user = _ref$row.user,
          userInfo = _ref$row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.user.remarkList,
            remark: scope.row.user.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.gender",
      label: "性别",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.user.gender == "0" ? _c("span", [_vm._v("未知")]) : _vm._e(), scope.row.user.gender == "1" ? _c("span", [_vm._v("男")]) : _vm._e(), scope.row.user.gender == "2" ? _c("span", [_vm._v("女")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.phone",
      label: "手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "user.occupation",
      label: "职业",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-lifestyle-table-link", {
          attrs: {
            id: scope.row.id,
            token: scope.row.token,
            title: scope.row.title
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "地址",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v(_vm._s(scope.row.location))]), scope.row.match_location ? _c("el-tag", {
          attrs: {
            type: scope.row.fraud == 2 ? "danger" : "info",
            size: "mini"
          }
        }, [_vm._v(_vm._s(scope.row.match_location))]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "collectNum",
      label: "收藏数",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "lookNum",
      label: "浏览数",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "shareNum",
      label: "分享数",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "状态",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == "2" ? _c("span", [_vm._v("审核失败")]) : _vm._e(), scope.row.status == "1" ? _c("span", [_vm._v("审核通过")]) : _vm._e(), scope.row.status == "0" ? _c("span", [_vm._v("未审核")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否推荐",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.isRecommend == "1" ? _c("span", [_vm._v("是")]) : _vm._e(), scope.row.isRecommend == "0" ? _c("span", [_vm._v("否")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "是否开放",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.subjectStatus == "1" ? _c("span", [_vm._v("未开放")]) : _vm._e(), scope.row.subjectStatus == "2" ? _c("span", [_vm._v("开放")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "城市标签",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.cityTxt.length == 0 ? _c("span", [_vm._v("无")]) : _vm._e(), _c("span", [_vm._v(_vm._s(scope.row.cityTxt.join("、")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "创建时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "update",
      label: "更新时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "160",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编 辑")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.audit(scope.row, 1);
            }
          }
        }, [_vm._v("通过")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.audit(scope.row, 2);
            }
          }
        }, [_vm._v("拒绝")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row.user);
            }
          }
        }, [_vm._v(" 备注 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRemarkObj.id,
      remark: _vm.currentRemarkObj.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };